import { render } from "./ErrorSession.vue?vue&type=template&id=69a74d01&ts=true"
import script from "./ErrorSession.vue?vue&type=script&lang=ts"
export * from "./ErrorSession.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__